import { createContext, useContext } from "react";
export type GemaAudience = "existing" | "new" | "pending";
export interface GemaExperienceState {
  enabled: boolean;
  version: "gema-launch-v1";
  audience: GemaAudience;
  introductionCompleted: boolean;
}
export type GemaExperienceStatus = "loading" | "ready" | "unavailable";
interface ContextValue { status: GemaExperienceStatus; experience: GemaExperienceState | null; loading: boolean; complete: () => Promise<boolean>; refresh: () => Promise<void>; }
export const Context = createContext<ContextValue>({ status: "ready", experience: null, loading: false, complete: async () => false, refresh: async () => {} });

export const useGemaExperience = () => useContext(Context);
